import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  bandeauAlertContainer,
  bandeauAlertIcon,
  bandeauAlertTitle,
  sectionAlertModal,
  sectionAlert,
  sectionAlertHeader,
  sectionAlertContent,
  sectionAlertButton,
  sectionAlertTitle,
} from "./bandeau-alert.module.scss"
import ContentTransformer from "../Transformers/content-transformer"
import {
  Title,
  SectionAlert,
  SectionAlertButton,
  SectionAlertContent,
  BandeauContainer,
} from "./bandeau-alert-styled"
import Icon from "../Icon/icon"

const BandeauAlert = ({ alertContent }) => {
  const [showAlert, setShowAlert] = useState(false)
  useEffect(() => {
    const visited = sessionStorage.alertBool
    if (visited) {
      setShowAlert(false)
    } else {
      setShowAlert(true)
      sessionStorage.setItem("alertBool", true)
    }
  }, [])
  return (
    <>
      {alertContent && (
        <>
          <BandeauContainer className={bandeauAlertContainer}>
            <div className={bandeauAlertIcon}>
              <Icon size={45} icon="notification"></Icon>
            </div>
            <h2 className={bandeauAlertTitle}>Message important</h2>
            <button
              onClick={() => {
                setShowAlert(true)
              }}
              className="btn"
            >
              Voir plus
            </button>
          </BandeauContainer>
          {showAlert && (
            <div className={sectionAlertModal}>
              <SectionAlert className={sectionAlert}>
                <div className={sectionAlertHeader}>
                  <Title className={sectionAlertTitle}>Message important</Title>
                  <SectionAlertButton
                    className={sectionAlertButton}
                    onClick={() => {
                      setShowAlert(false)
                      sessionStorage.setItem("alertBool", true)
                    }}
                  >
                    &times;
                  </SectionAlertButton>
                </div>
                <SectionAlertContent className={sectionAlertContent}>
                  <ContentTransformer
                    content={alertContent}
                  ></ContentTransformer>
                </SectionAlertContent>
              </SectionAlert>
            </div>
          )}
        </>
      )}
    </>
  )
}

//-----------------------Prop-Types---------------------------//

BandeauAlert.propTypes = {
  alertContent: PropTypes.string,
}

//-----------------------Prop-Types---------------------------//

export default BandeauAlert
